import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
// import { Store } from '@ngrx/store';
import { userProfile } from '../../models/userProfile';
import { AdvisoryLead } from '../../models/AdvisoryLead';
import { DataService } from './../../services/data.service';
import { AccountService } from '../../services/account.service';
import { AdminService } from '../../services/Admin.service';
import { Code } from '../../models/Code';
import { ModalComponent } from '../../shared-components/modal/modal.component';
import { BusyIndicatorComponent } from '../../shared-components/busy-indicator/busy-indicator.component';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-advisoryservices',
  templateUrl: './advisoryservices.component.html',
  styleUrls: ['./advisoryservices.component.scss']
})
export class AdvisoryservicesComponent implements OnInit {
  public user: userProfile;
  public userInfo: any;
  public name = '';
  public countries: Code[];
  public loAdvisoryLead: AdvisoryLead;
  public formGroup: FormGroup;
  private alive = true;
  @ViewChild('confirmationpopup') confirmationpopup: ModalComponent;
  // tslint:disable-next-line:max-line-length
  public states = [{ label: "Alabama", code: "AL" }, { label: "Alaska", code: "AK" }, { label: "American Samoa", code: "AS" }, { label: "Arizona", code: "AZ" }, { label: "Arkansas", code: "AR" }, { label: "California", code: "CA" }, { label: "Colorado", code: "CO" }, { label: "Connecticut", code: "CT" }, { label: "Delaware", code: "DE" }, { label: "District Of Columbia", code: "DC" }, { label: "Federated States Of Micronesia", code: "FM" }, { label: "Florida", code: "FL" }, { label: "Georgia", code: "GA" }, { label: "Guam", code: "GU" }, { label: "Hawaii", code: "HI" }, { label: "Idaho", code: "ID" }, { label: "Illinois", code: "IL" }, { label: "Indiana", code: "IN" }, { label: "Iowa", code: "IA" }, { label: "Kansas", code: "KS" }, { label: "Kentucky", code: "KY" }, { label: "Louisiana", code: "LA" }, { label: "Maine", code: "ME" }, { label: "Marshall Islands", code: "MH" }, { label: "Maryland", code: "MD" }, { label: "Massachusetts", code: "MA" }, { label: "Michigan", code: "MI" }, { label: "Minnesota", code: "MN" }, { label: "Mississippi", code: "MS" }, { label: "Missouri", code: "MO" }, { label: "Montana", code: "MT" }, { label: "Nebraska", code: "NE" }, { label: "Nevada", code: "NV" }, { label: "New Hampshire", code: "NH" }, { label: "New Jersey", code: "NJ" }, { label: "New Mexico", code: "NM" }, { label: "New York", code: "NY" }, { label: "North Carolina", code: "NC" }, { label: "North Dakota", code: "ND" }, { label: "Northern Mariana Islands", code: "MP" }, { label: "Ohio", code: "OH" }, { label: "Oklahoma", code: "OK" }, { label: "Oregon", code: "OR" }, { label: "Palau", code: "PW" }, { label: "Pennsylvania", code: "PA" }, { label: "Puerto Rico", code: "PR" }, { label: "Rhode Island", code: "RI" }, { label: "South Carolina", code: "SC" }, { label: "South Dakota", code: "SD" }, { label: "Tennessee", code: "TN" }, { label: "Texas", code: "TX" }, { label: "Utah", code: "UT" }, { label: "Vermont", code: "VT" }, { label: "Virgin Islands", code: "VI" }, { label: "Virginia", code: "VA" }, { label: "Washington", code: "WA" }, { label: "West Virginia", code: "WV" }, { label: "Wisconsin", code: "WI" }, { label: "Wyoming", code: "WY" }];

  constructor(
    private dataSvc: DataService,
    private accountsvc: AccountService,
    private adminSvc: AdminService,
    private spinner: NgxSpinnerService


  ) {
    this.getCountries();
   }
  getCountries() {
    this.adminSvc.getCountries()
    .takeWhile(() => this.alive)
    .subscribe(data => {
      this.countries = data;
      console.log(this.countries);
    });
  }
ngOnInit(): void {
    this.loAdvisoryLead = new AdvisoryLead();



}





onFormSubmit() {

   console.log(this.loAdvisoryLead);
   this.spinner.show();
   this.accountsvc.createAdvisoryLead(this.loAdvisoryLead).subscribe(
    data => {
               console.log(data);
               this.spinner.hide();
               if (data.Success) {
                 this.loAdvisoryLead = new AdvisoryLead();
                 this.confirmationpopup.show();
               }
          },
    err => {
      this.spinner.hide();
      console.log(err);

    }
  );

}
}



// WEBPACK FOOTER //
// ./src/app/pages/advisoryservices/advisoryservices.component.ts